import { useEffect } from 'react';
import {
  GTM_DOM_MARKERS,
  getRaid2026GtmBodyNoscriptHtml,
  getRaid2026GtmHeadScriptHtml,
  RAID2026_GTM_CONTAINER_ID,
} from '../config/gtm';

const injectRaid2026Gtm = () => {
  if (document.querySelector(`script[${GTM_DOM_MARKERS.headScript}]`)) {
    return () => {};
  }

  const headTemplate = document.createElement('template');
  headTemplate.innerHTML = getRaid2026GtmHeadScriptHtml().trim();
  const headScript = headTemplate.content.firstElementChild;
  document.head.prepend(headScript);

  const bodyTemplate = document.createElement('template');
  bodyTemplate.innerHTML = getRaid2026GtmBodyNoscriptHtml().trim();
  const bodyNoscript = bodyTemplate.content.firstElementChild;
  document.body.prepend(bodyNoscript);

  return () => {
    headScript.remove();
    bodyNoscript.remove();
  };
};

/**
 * RAID 2026 LP 専用の Google Tag Manager を head / body 先頭へ挿入する。
 * production 環境のみ有効（stg / preview / local では計測データを汚さない）。
 */
export default function useGoogleTagManager(enabled) {
  useEffect(() => {
    if (!enabled || !RAID2026_GTM_CONTAINER_ID) {
      return undefined;
    }

    return injectRaid2026Gtm();
  }, [enabled]);
}
